"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DashboardLayoutSectionHeaderDescription_1 = require("./DashboardLayoutSectionHeaderDescription");
exports.DashboardLayoutSectionHeader = function (props) {
    var title = props.title, description = props.description, renderBeforeHeader = props.renderBeforeHeader, renderHeader = props.renderHeader;
    return (react_1.default.createElement("div", { className: "gd-fluid-layout-row-header s-fluid-layout-row-header" },
        renderBeforeHeader,
        react_1.default.createElement("div", { className: "gd-fluid-layout-row-header-container" }, renderHeader !== null && renderHeader !== void 0 ? renderHeader : (react_1.default.createElement("div", { className: "gd-row-header-view" },
            title && (react_1.default.createElement("div", { className: "gd-row-header-title-wrapper" },
                react_1.default.createElement("span", { className: "title" },
                    react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h2", className: "s-fluid-layout-row-title" }, title)))),
            description && react_1.default.createElement(DashboardLayoutSectionHeaderDescription_1.DashboardLayoutSectionHeaderDescription, { description: description }))))));
};
//# sourceMappingURL=DashboardLayoutSectionHeader.js.map